<div class="strech">
    <ngx-loading [show]="loader" [config]="{backdropBackgroundColour: 'rgba(255,255,255,0.3)'}"></ngx-loading>
    <iframe class="strech" id="frame" (load)="success()" src="https://reports.estater.com/public/dashboard/b887a09e-1de6-456b-aa9d-13f9bab9be88" title="Dashboard"></iframe>
</div>